import { Button } from '@kanos/ui';
import { PageNotice, SignInGate, type Me } from '@kanos/web-core';
import type { ReactNode } from 'react';
import { MeContext } from './me';
import { useSwitchFirm } from './session';

function FirmChooser({ me }: { me: Me }) {
  const switchFirm = useSwitchFirm();
  return (
    <PageNotice title="In welcher Kanzlei möchten Sie arbeiten?">
      <ul className="grid gap-2">
        {me.firms.map((firm) => (
          <li key={firm.tenantId}>
            <Button
              variant="secondary"
              size="lg"
              className="w-full"
              isPending={switchFirm.isPending && switchFirm.variables === firm.tenantId}
              isDisabled={switchFirm.isPending && switchFirm.variables !== firm.tenantId}
              onPress={() => {
                switchFirm.mutate(firm.tenantId);
              }}
            >
              {firm.name}
            </Button>
          </li>
        ))}
      </ul>
      {switchFirm.isError && (
        <p role="alert" className="text-sm text-danger-fg">
          Die Kanzlei konnte nicht gewählt werden. Bitte versuchen Sie es erneut.
        </p>
      )}
    </PageNotice>
  );
}

/**
 * Lets the firm app render only for a signed-in person working in a firm: signing in is the
 * shared gate's (`SignInGate`); here the person picks a firm, if there is a choice.
 */
export function SessionGate({ children }: { children: ReactNode }) {
  return (
    <SignInGate>
      {(me) => {
        if (me.firms.length === 0) {
          return (
            <PageNotice title="Ihr Konto ist noch keiner Kanzlei zugeordnet">
              <p className="text-muted">
                Bitten Sie die Administration Ihrer Kanzlei, Sie in Kanos einzuladen.
              </p>
            </PageNotice>
          );
        }
        if (me.activeTenantId === null) return <FirmChooser me={me} />;
        return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
      }}
    </SignInGate>
  );
}
